import { Pipe, PipeTransform } from '@angular/core';
import { Observable, isObservable, of } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Pipe({
   name: 'debounceTime',
})
export class DebounceTimePipe implements PipeTransform {
   transform(value: any | Observable<any>, time: number): Observable<any> {
      const inputValue$ = isObservable(value) ? value : of(value);
      return inputValue$.pipe(debounceTime(time));
   }
}
